import { render, staticRenderFns } from "./SchoolFormModal.vue?vue&type=template&id=5a739ad4&scoped=true&"
import script from "./SchoolFormModal.vue?vue&type=script&lang=js&"
export * from "./SchoolFormModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a739ad4",
  null
  
)

export default component.exports